/* tslint:disable */
/* eslint-disable */

/**
 * 0 = NoDefect
 * 
 * 1 = SeeDefectReport
 * 
 * 2 = NotFound
 */
export enum Form10AStatus {
  NoDefect = 0,
  SeeDefectReport = 1,
  NotFound = 2
}
